import React, { useEffect, useState } from "react";
import {
  Box,
  Button,
  Checkbox,
  FormControl,
  FormControlLabel,
  IconButton,
  InputAdornment,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  Tooltip,
  Typography,
} from "@mui/material";
import { Controller, useForm } from "react-hook-form";
import { pageScrollStyle } from "../../../../styles/styles";
import { inputTypes } from "../../../CustomeFields";
import DeleteRoundedIcon from "@mui/icons-material/DeleteRounded";
import { AddRounded } from "@mui/icons-material";
import { useDispatch, useSelector } from "react-redux";
import {
  createCustomField,
  getAllCustomField,
} from "../../../../redux/Apps/Lawyerapp/CustomFieldSlice";
import { backend_api } from "../../../../static/server";
import { LoadingButton } from "@mui/lab";
import { useDialog } from "../../../DialogContext";
import { toast } from "react-toastify";

const CustomFieldForm = ({ forWhichForm }) => {
  const dispatch = useDispatch();
  const { closeDialog } = useDialog();
  const [optionLenError, setOptionLenError] = useState(false);
  const [optionCount, setOptionCount] = useState(2);
  const { token } = useSelector((data) => data.user);
  const { userId } = useSelector((state) => state?.user);
  const { lawerId } = useSelector((state) => state?.user);

  useEffect(() => {
    dispatch(
      getAllCustomField({
        url: forWhichForm
          ? `${backend_api}custom-field/?field_for=${forWhichForm}`
          : `${backend_api}custom-field/`,
        token: token,
      })
    );
  }, [dispatch, token]);
  const {
    control,
    handleSubmit,
    reset,
    watch,
    formState: { errors },
  } = useForm({
    defaultValues: {
      created_by: userId,
      under_lawer: lawerId,
      field_for: "contact",
      field_name: "",
      field_data: {
        type: "",
        placeholder: "",
        // validation: false,
        required: false,
        default_apply: false,
        options: [],
      },
    },
  });

  const field_type = watch("field_data.type");

  const onSubmit = async (data, e) => {
    e.preventDefault();

    if (data?.field_data?.type === "select") {
      const validOptions = data?.field_data?.options.filter(
        (option) => option && option?.trim() !== ""
      );

      if (validOptions?.length < 2) {
        toast.error("Select type fields must have at least 2 options");
        return;
      }

      data.field_data.options = validOptions;
    }

    try {
      await dispatch(
        createCustomField({
          url: `${backend_api}custom-field/`,
          body: data,
          token: token,
        })
      ).unwrap();
      toast.success("Custom Field created successfully");

      // Refresh the list
      await dispatch(
        getAllCustomField({
          url: forWhichForm
            ? `${backend_api}custom-field/?field_for=${forWhichForm}`
            : `${backend_api}custom-field/`,
          token: token,
        })
      ).unwrap();

      reset();
      closeDialog();
    } catch (error) {
      toast.error(
        error?.message || "Failed to save the field. Please try again."
      );
    }
  };

  const handleDeleteOption = (i) => {
    if (optionCount === 2) {
      setOptionLenError(true);
    } else {
      setOptionCount(optionCount - 1);
    }
  };
  return (
    <>
      <Box>
        <form onSubmit={handleSubmit(onSubmit)}>
          <Box
            sx={{
              display: "flex",
              gap: "1rem",
              flexDirection: "column",
              p: "1rem",
            }}
          >
            <Box>
              <Controller
                name="field_name"
                control={control}
                rules={{ required: true }}
                render={({ field }) => (
                  <TextField
                    {...field}
                    fullWidth
                    size="small"
                    label="Field Name"
                    error={errors.field_data?.type}
                  />
                )}
              />
              {errors.field_name && (
                <Typography color="error" sx={{ fontSize: "0.8rem" }}>
                  This field is required
                </Typography>
              )}
            </Box>
            <Box>
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                {optionLenError ? (
                  <Typography color="error" sx={{ fontSize: "0.8rem" }}>
                    This type contain minimum 2 options.
                  </Typography>
                ) : null}
              </Box>
              <Controller
                name="field_data.type"
                control={control}
                rules={{ required: true }}
                render={({ field }) => (
                  <FormControl
                    size="small"
                    fullWidth
                    error={errors?.field_data?.type}
                  >
                    <InputLabel
                      id="field_data-label"
                      sx={{ bgcolor: "#fff", px: "0.3rem" }}
                    >
                      Type
                    </InputLabel>
                    <Select
                      {...field}
                      size="small"
                      fullWidth
                      MenuProps={{
                        sx: {
                          zIndex: 2000,
                          height: "20rem",
                          ...pageScrollStyle,
                        },
                      }}
                    >
                      {inputTypes.map((item, i) => (
                        <MenuItem key={i} value={item}>
                          {item}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                )}
              />
              {errors.field_data?.type && (
                <Typography color="error" sx={{ fontSize: "0.8rem" }}>
                  This field is required
                </Typography>
              )}
              {field_type === "select" ? (
                <Box
                  sx={{
                    mt: "0.5rem",
                    display: "flex",
                    justifyContent: "center ",
                    alignItems: "center",
                    gap: "1rem",
                  }}
                >
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      gap: "0.5rem",
                      width: "100%",
                      maxHeight: "6rem",
                      overflowX: "auto",
                      ...pageScrollStyle,
                      pt: "0.3rem",
                    }}
                  >
                    {[...Array(optionCount)].map((item, i) => (
                      <Controller
                        key={i}
                        name={`field_data.options.${i}`}
                        control={control}
                        rules={{ required: true }}
                        render={({ field }) => (
                          <TextField
                            {...field}
                            error={errors.field_data?.options}
                            fullWidth
                            size="small"
                            label={`option${i + 1}`}
                            value={field.value || ""}
                            slotProps={{
                              input: {
                                endAdornment: (
                                  <InputAdornment position="end">
                                    <Tooltip title="delete">
                                      <IconButton
                                        onClick={() => handleDeleteOption(i)}
                                      >
                                        <DeleteRoundedIcon
                                          sx={{ fontSize: "1.3rem " }}
                                        />
                                      </IconButton>
                                    </Tooltip>
                                  </InputAdornment>
                                ),
                              },
                            }}
                          />
                        )}
                      />
                    ))}
                    {errors.field_data?.options && (
                      <Typography color="error" sx={{ fontSize: "0.8rem" }}>
                        These field is required
                      </Typography>
                    )}
                  </Box>
                  <Tooltip title="Add options">
                    <IconButton
                      color="primary"
                      onClick={() => {
                        setOptionCount(optionCount + 1);
                        setOptionLenError(false);
                      }}
                    >
                      <AddRounded />
                    </IconButton>
                  </Tooltip>
                </Box>
              ) : null}
            </Box>
            <Box>
              <Controller
                name="field_data.required"
                control={control}
                render={({ field: { onChange, value, ...field } }) => (
                  <FormControlLabel
                    control={
                      <Checkbox
                        {...field}
                        checked={!!value}
                        onChange={(e) => onChange(e.target.checked)}
                        size="small"
                      />
                    }
                    label={
                      <Typography sx={{ fontSize: "0.9rem", fontWeight: 400 }}>
                        Required
                      </Typography>
                    }
                  />
                )}
              />
              {/* <Controller
                name="field_data.validation"
                control={control}
                render={({ field: { onChange, value, ...field } }) => (
                  <FormControlLabel
                    control={
                      <Checkbox
                        {...field}
                        checked={!!value}
                        onChange={(e) => onChange(e.target.checked)}
                        size="small"
                      />
                    }
                    label={
                      <Typography sx={{ fontSize: "0.9rem", fontWeight: 400 }}>
                        Validation
                      </Typography>
                    }
                  />
                )}
              /> */}
            </Box>
          </Box>
          <Box
            sx={{
              height: "fit-content",
              borderTop: "1px solid #ddd",
              position: "sticky",
              bottom: 0,
              backdropFilter: "blur(10px)",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              p: "0.5rem",
              zIndex: 1000,
              gap: "0.5rem",
            }}
          >
            <Controller
              name="field_data.default_apply"
              control={control}
              render={({ field: { onChange, value, ...field } }) => (
                <FormControlLabel
                  control={
                    <Checkbox
                      {...field}
                      checked={!!value}
                      onChange={(e) => onChange(e.target.checked)}
                      size="small"
                    />
                  }
                  label={
                    <Typography sx={{ fontSize: "0.9rem", fontWeight: 400 }}>
                      Default apply on form
                    </Typography>
                  }
                />
              )}
            />
            <Box sx={{ display: "flex", gap: "1rem" }}>
              <Button
                variant="outlined"
                size="small"
                onClick={() => closeDialog()}
              >
                Cancel
              </Button>
              <LoadingButton
                //   loading={submitLoading}
                variant="contained"
                color="primary"
                type="submit"
                size="small"
              >
                Create Field
              </LoadingButton>
            </Box>
          </Box>
        </form>
      </Box>
    </>
  );
};

export default CustomFieldForm;
